module.exports = __webpack_public_path__ + "static/img/all_game.ec02ec5f.png";